module.exports = __webpack_public_path__ + "static/media/accounts_vendors_manage.82e308d2.svg";